import React from "react";
import { ArrowLeft, ShieldCheck } from "lucide-react";

const TermsPage = ({ navigateTo }) => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12 animate-in fade-in duration-300">
      <button
        onClick={() => navigateTo("home")}
        className="mb-6 flex items-center text-sm font-bold text-slate-500 hover:text-green-600 transition w-fit"
      >
        <ArrowLeft className="w-4 h-4 mr-2" /> Zpět na hlavní stránku
      </button>

      <div className="bg-white p-8 md:p-12 rounded-2xl border border-slate-200 shadow-sm">
        <div className="flex flex-col md:flex-row md:items-center gap-4 mb-8 border-b border-slate-100 pb-6">
          <ShieldCheck className="w-10 h-10 text-green-600 flex-shrink-0" />
          <div>
            <h1 className="text-3xl font-bold text-[#2a3b4c]">
              Obchodní podmínky a GDPR
            </h1>
            <p className="text-slate-500 mt-1">Platné a účinné od 1. 1. 2024</p>
          </div>
        </div>

        <div className="space-y-6 text-slate-600 leading-relaxed text-[15px]">
          
          {/* Identifikační údaje */}
          <div className="bg-slate-50 p-6 rounded-xl border border-slate-200 mb-8">
            <h2 className="font-bold text-slate-800 mb-3 text-lg">Základní údaje provozovatele</h2>
            <ul className="space-y-2">
              <li><strong>Prodávající a provozovatel:</strong> František Malina (e-shop Elektrokit.cz)</li>
              <li><strong>Sídlo:</strong> L.Želiny 502/5, 286 01, Čáslav - Nové Město</li>
              <li><strong>IČO:</strong> 29547563 (Nejsem plátce DPH)</li>
              <li><strong>Zapsán v živnostenském rejstříku:</strong> Obecní živnostenský úřad Čáslav</li>
              <li><strong>Provozovaný e-shop:</strong> www.elektrokit.cz</li>
              <li><strong>Kontaktní e-mail:</strong> elektrokit@seznam.cz</li>
              <li><strong>Telefon:</strong> +420 723 924 260</li>
            </ul>
          </div>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-3">1. Úvodní ustanovení</h2>
            <p className="mb-2">
              1.1. Tyto obchodní podmínky (dále jen „obchodní podmínky“) prodávajícího <strong>Františka Maliny</strong> (dále jen „prodávající“) upravují vzájemná práva a povinnosti vzniklé v souvislosti nebo na základě kupní smlouvy uzavírané mezi prodávajícím a jinou fyzickou osobou (dále jen „kupující“) prostřednictvím internetového obchodu www.elektrokit.cz.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-3">2. Uzavření kupní smlouvy</h2>
            <p className="mb-2">
              2.1. Veškerá prezentace zboží ve webovém rozhraní je informativního charakteru a prodávající není povinen uzavřít kupní smlouvu ohledně tohoto zboží.
            </p>
            <p className="mb-2">
              2.2. Smluvní vztah mezi prodávajícím a kupujícím vzniká doručením přijetí objednávky (akceptací), jež je prodávajícím zasláno kupujícímu elektronickou poštou na adresu uvedenou v objednávce.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-3">3. Cena zboží a platební podmínky</h2>
            <p className="mb-2">
              3.1. Cenu zboží a případné náklady spojené s dodáním může kupující uhradit následujícími způsoby:
            </p>
            <ul className="list-disc pl-5 mb-2 space-y-1">
              <li>v hotovosti na dobírku při převzetí zboží,</li>
              <li>bezhotovostně převodem na bankovní účet prodávajícího,</li>
              <li><strong>bezhotovostně online platební kartou</strong> prostřednictvím zabezpečené platební brány <strong>Stripe</strong>. Prodávající nemá přístup k citlivým údajům o platební kartě kupujícího, tyto údaje zpracovává výhradně provozovatel platební brány.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-3">4. Legislativa a provoz na pozemních komunikacích</h2>
            <p className="mb-2">
              4.1. Prodávané přestavbové sady (dodatečně montované pomocné motorky) splňují podmínky vyhlášky č. 341/2014 Sb. pro provoz na pozemních komunikacích za předpokladu, že jejich nominální výkon nepřesáhne 1000 W a asistence motoru je softwarově či hardwarově omezena na maximální rychlost 25 km/h.
            </p>
            <p className="mb-2">
              4.2. <strong>Zřeknutí se odpovědnosti:</strong> Pokud kupující svévolně odblokuje rychlostní limit nad 25 km/h, zvýší výkon nad zákonný rámec, nebo jinak zasáhne do řídící jednotky, bere na vědomí, že takto upravené jízdní kolo okamžitě ztrácí způsobilost pro provoz na veřejných pozemních komunikacích a smí být používáno výhradně mimo ně (off-road, soukromé pozemky).
            </p>
            <p className="mb-2">
              4.3. Prodávající nenese absolutně žádnou právní, finanční ani trestní odpovědnost za případné škody na majetku, zdraví, či za pokuty způsobené nedodržením platné legislativy, nerespektováním dopravních předpisů nebo jízdou s odblokovaným motorem na veřejných komunikacích.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-3">5. Odpovědnost za stav kola a odborná montáž</h2>
            <p className="mb-2">
              5.1. <strong>Montáž prováděná prodávajícím:</strong> V případě, že se kupující dohodne s prodávajícím na instalaci přestavbové sady, je kupující povinen dodat své jízdní kolo v plně funkčním a pojízdném technickém stavu. Prodávající přebírá odpovědnost výhradně za díly, které na kolo v rámci sady přidal, a za jejich správné uchycení.
            </p>
            <p className="mb-2">
              5.2. Prodávající nenese odpovědnost za následné škody způsobené nesprávným zacházením ze strany kupujícího (např. chybné řazení pod plným tahem motoru), ani za poškození původních komponentů kola (přetržení řetězu, zničení kazety, selhání brzd či prasknutí rámu) vlivem zvýšené zátěže a kroutícího momentu motoru.
            </p>
            <p className="mb-2">
              5.3. <strong>Vlastní montáž kupujícím:</strong> Zvolí-li kupující montáž svépomocí, plně odpovídá za to, že je jeho jízdní kolo k této přestavbě technicky způsobilé (zejména z hlediska pevnosti rámu a účinnosti brzd). Za případné zničení komponentů přestavbové sady z důvodu neodborné montáže nenese prodávající žádnou odpovědnost.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-3">6. Odstoupení od kupní smlouvy (Vrácení do 14 dnů)</h2>
            <p className="mb-2">
              6.1. Kupující má v souladu s § 1829 odst. 1 občanského zákoníku právo od kupní smlouvy odstoupit do čtrnácti (14) dnů od převzetí zboží. Náklady spojené s navrácením zboží prodávajícímu nese plně kupující.
            </p>
            <p className="mb-2">
              6.2. <strong>Podmínky vrácení sady:</strong> Kupující bere na vědomí, že vrácené zboží nesmí jevit známky hrubé nebo trvalé montáže. Pokud bude vrácený motor poškrábaný (např. od montážních klíčů), kabeláž bude zkrácena, nebo budou konektory poškozeny, má prodávající právo ponížit vracenou částku o náklady spojené s uvedením zboží do původního stavu, a to až do výše 100 % kupní ceny (v případě nevratného zničení).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-3">7. Práva z vadného plnění (Reklamace)</h2>
            <p className="mb-2">
              7.1. Prodávající odpovídá kupujícímu, že zboží při převzetí nemá vady. Kupující je oprávněn uplatnit právo z vady, která se vyskytne u spotřebního zboží v době dvaceti čtyř (24) měsíců od převzetí.
            </p>
            <p className="mb-2">
              7.2. <strong>Posouzení reklamace:</strong> O oprávněnosti reklamace rozhoduje na základě fyzické prohlídky zboží výhradně prodávající. 
            </p>
            <p className="mb-2">
              7.3. <strong>Výluky ze záruky:</strong> Záruka se nevztahuje na opotřebení zboží způsobené jeho obvyklým užíváním. Záruka nebude uznána zejména v případech zjevného mechanického poškození zaviněného kupujícím (např. pád baterie a následné uvolnění článků uvnitř obalu, poškození displeje nárazem) nebo při poškození způsobeném neodborným zásahem do kabeláže. Komponenty sady disponují certifikací odolnosti proti vodě (zvládnou déšť i běžné mytí), záruka se však nevztahuje na vniknutí vody do elektroniky způsobené extrémním tlakem (mytí vysokotlakým čističem - wapkou) nebo úplným ponořením motoru pod hladinu vody.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-3">8. Mimosoudní řešení sporů</h2>
            <p className="mb-2">
              8.1. K mimosoudnímu řešení spotřebitelských sporů z kupní smlouvy je příslušná Česká obchodní inspekce, se sídlem Štěpánská 567/15, 120 00 Praha 2, internetová adresa: <a href="https://adr.coi.cz/cs" target="_blank" rel="noreferrer" className="text-green-600 hover:underline">https://adr.coi.cz/cs</a>.
            </p>
          </section>

          <hr className="my-10 border-slate-200" />

          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-4">9. Ochrana osobních údajů (GDPR)</h2>
            <p className="mb-4">
              Správcem vašich osobních údajů je <strong>František Malina, IČO: 29547563</strong> (provozovatel e-shopu Elektrokit.cz). Zpracování osobních údajů probíhá v souladu s Nařízením Evropského parlamentu a Rady (EU) 2016/679 (GDPR).
            </p>
            <ul className="list-disc pl-5 space-y-3">
              <li>
                <strong>Jaká data zpracováváme a proč:</strong> Zpracováváme vaše jméno, příjmení, doručovací/fakturační adresu, e-mail a telefonní číslo výhradně pro vyřízení objednávky a plnění zákonných povinností.
              </li>
              <li>
                <strong>Kdo má k datům přístup:</strong> Vaše údaje předáváme pouze vybraným přepravcům za účelem doručení zásilky. Nikomu jinému data neprodáváme ani neposkytujeme pro marketing.
              </li>
              <li>
                <strong>Vaše práva:</strong> Máte právo požádat o přístup ke svým osobním údajům, jejich opravu, nebo úplné vymazání z naší databáze. Pro uplatnění práv nás kontaktujte na <strong>elektrokit@seznam.cz</strong>.
              </li>
            </ul>
          </section>

        </div>
      </div>
    </div>
  );
};

export default TermsPage;